/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Pause_Reasons_ColorInputs */

const en_tables_pause_reasons_color = /** @type {(inputs: Tables_Pause_Reasons_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reasons Color`)
};

const de_tables_pause_reasons_color = /** @type {(inputs: Tables_Pause_Reasons_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Farbe`)
};

/**
* | output |
* | --- |
* | "Reasons Color" |
*
* @param {Tables_Pause_Reasons_ColorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_pause_reasons_color = /** @type {((inputs?: Tables_Pause_Reasons_ColorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Pause_Reasons_ColorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_pause_reasons_color(inputs)
	return de_tables_pause_reasons_color(inputs)
});